/** Detect installed PWA, iOS Safari, Android install support, and in-app browsers. */

export function isStandalonePwa(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

export function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) && !(window as Window & { MSStream?: unknown }).MSStream;
}

export function isAndroidDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

/** Instagram, Telegram, etc. — Add to Home Screen is blocked or unreliable. */
export function isInAppBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /(FBAN|FBAV|Instagram|Line\/|Twitter|Telegram|WhatsApp)/i.test(ua);
}

export function supportsWebPush(): boolean {
  return (
    typeof window !== 'undefined' &&
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window
  );
}

/** Safe read — iOS Safari tab has no Notification API (only installed PWA). */
export function getNotificationPermission(): NotificationPermission | null {
  if (!supportsWebPush()) return null;
  return Notification.permission;
}

export function isNotificationGranted(): boolean {
  return getNotificationPermission() === 'granted';
}

export type InstallPromptKind = 'ios' | 'android' | 'none';

export function resolveInstallPromptKind(): InstallPromptKind {
  if (isStandalonePwa()) return 'none';
  if (isIosDevice() && !isInAppBrowser()) return 'ios';
  if (isAndroidDevice() && !isInAppBrowser()) return 'android';
  return 'none';
}
